// extracted by mini-css-extract-plugin
export var active = "_bi-d";
export var blink = "_bi-e";
export var container = "_bi-5";
export var controls = "_bi-0";
export var controlsRight = "_bi-1";
export var fakeCursor = "_bi-c";
export var hidden = "_bi-b";
export var quillContainerSmall = "_bi-7";
export var quillEditor = "_bi-6";
export var quillEditorSmall = "_bi-8";
export var quillFormatButtons = "_bi-a";
export var quillToolbar = "_bi-9";
export var removePadding = "_bi-2";
export var state = "_bi-3";
export var stateTitle = "_bi-4";